import { Component } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable,map, startWith } from 'rxjs';
import { DatatableConfig } from 'src/app/config/DatatableConfig';
import { ReemplazoDocenteService } from 'src/app/services/reemplazo-docente/reemplazo-docente.service';
import { IResCrearReemplazoDocente } from 'src/app/interfaces/reemplazo-docente';
import { DatePipe } from '@angular/common';
import { UtilsFnService } from 'src/app/services/utils/utils-fn.service';

@Component({
  selector: 'app-view-reemplazo-docente-editar',
  templateUrl: './view-reemplazo-docente-editar.component.html',
  styleUrls: ['./view-reemplazo-docente-editar.component.scss']
})
export class ViewReemplazoDocenteEditarComponent {
  dtOptions: DataTables.Settings =  { ...DatatableConfig.dtSortWithoutSearch }
  renderTable: boolean = false

  listaNombreDocentesReemplazo: any = []
  searchCodDocenteReemplazoForm = new FormControl('')
  filteredCodDocentesReemplazo: Observable<Array<any>>

  listaNombreDocentes: any = []
  searchCodDocenteForm = new FormControl('')
  searchNombreDocenteForm = new FormControl('')

  reemplazoDocenteForm = this.formBuilder.group({
    idDocenteReemplazo: ['']
  })

  tieneErrores: any = {}
  submitted: boolean = false
  activarTodos: boolean = true
  nombreDocenteReemplazo: string = ''

  fechaInicioDocenteReemplazo:any
  fechaFinDocenteReemplazo:any

  infoModalTitulo: string = ''
  infoModalTexto: string = ''

  reemplazo: any = {};

  fechaDisabled: boolean = false;

  ngOnInit(): void {
    this.dtOptions = { ...DatatableConfig.dtSortWithoutSearch }

    this.obtenerDocentes(this.reemplazo.anoAcademico,this.reemplazo.periodoAcademicoId);

    let inicioArray = this.reemplazo.fechaInicio.split('/');
    let convertedInicioDate = new Date(inicioArray[1]+'-'+inicioArray[0]+' '+inicioArray[2]);

    if(convertedInicioDate < new Date()){
      this.fechaDisabled = true;
    }

    let dateTerminoArray = this.reemplazo.fechaTermino.split('/');
    let convertedTerminoDate = new Date(dateTerminoArray[1]+'-'+dateTerminoArray[0]+' '+dateTerminoArray[2]);

    this.fechaInicioDocenteReemplazo = this.datePipe.transform(convertedInicioDate, 'yyyy-MM-dd');
    this.fechaFinDocenteReemplazo =  this.datePipe.transform(convertedTerminoDate, 'yyyy-MM-dd');
  }

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private _reemplazoDocente: ReemplazoDocenteService,
    private datePipe:DatePipe,
    private _utilsFn: UtilsFnService
  ) {
    const routerData = this.router.getCurrentNavigation()?.extras?.state?.['data']
    if ( routerData?.reemplazo ) {
      this.reemplazo = routerData.reemplazo
      this.nombreDocenteReemplazo = this.reemplazo.nombreDocenteReemplazo;
      this.searchCodDocenteReemplazoForm.patchValue(this.reemplazo.codigoDocenteReemplazo, {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: false})
    } 
    if ( !routerData ) {
      this.navToInicioReemplazoDocente();
    }

    this.filteredCodDocentesReemplazo = this.searchCodDocenteReemplazoForm.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', 'codDocenteReemplazo')),
    )
  }

  private _normalizeValue(value: string): string {
    return value?.toLowerCase()?.normalize("NFD")?.replace(/[\u0300-\u036f]/g, '')
  }

  private _filter(value: string, type: string): string[] {
    if (typeof value != 'string') {
      return []
    }
    const filterValue = this._normalizeValue(value)
    if ( type === 'codDocenteReemplazo' ) {
      return this.listaNombreDocentesReemplazo.filter((docente: any) => this._normalizeValue(docente?.codigo)?.includes(filterValue) )
    }
    if ( type === 'cod' ) {
      return this.listaNombreDocentes.filter((docente: any) => this._normalizeValue(docente?.codigo)?.includes(filterValue) )
    } else {
      return this.listaNombreDocentes.filter((docente: any) => this._normalizeValue(`${docente?.primerNombre} ${docente?.apellidoPat} ${docente?.apellidoMat}`)?.includes(filterValue) )
    }
  }

  buscarDocenteReemplazo() {
    const docenteReemplazo: any = typeof this.searchCodDocenteReemplazoForm.getRawValue() === 'object' ? this.searchCodDocenteReemplazoForm.getRawValue() : ''
    if ( docenteReemplazo?.funcionarioId ) {
      this.fechaInicioDocenteReemplazo = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.nombreDocenteReemplazo = `${docenteReemplazo?.primerNombre} ${docenteReemplazo?.apellidoPat} ${docenteReemplazo?.apellidoMat}`
    }
  }

  resetearValidacion(tipo: string = 'default') {
    this.submitted = false
    this.tieneErrores["idDocenteReemplazo"] = false
    this.tieneErrores["fechaInicioDocenteReemplazo"] = false
    this.tieneErrores["fechaFinDocenteReeemplazo"] = false
  }

  obtenerDocentes(anyo: number, periodoId: number, sedeId: number = 0, seccionId: number = 0): void {
    this._reemplazoDocente.obtenerListaDocentesBackoffice(anyo, periodoId, sedeId, seccionId).subscribe((res: any) => {
      this.listaNombreDocentes = res

      if ( sedeId === 0 && seccionId === 0 ) {
        this.listaNombreDocentesReemplazo = res
        this.filteredCodDocentesReemplazo = this.searchCodDocenteReemplazoForm.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value || '', 'codDocenteReemplazo')),
        )
      }
      const dataDocente: any = this.listaNombreDocentesReemplazo.find((x:any) => x.funcionarioId == this.reemplazo.idDocenteReemplazo);
      this.searchCodDocenteReemplazoForm.patchValue(dataDocente, {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: false})
    })
  }

  limpiarFiltrosDocenteReemplazo() {
    if(!this.fechaDisabled){
      this.fechaInicioDocenteReemplazo = ''
    }
    this.fechaFinDocenteReemplazo = ''
    this.nombreDocenteReemplazo = ''

    this.searchCodDocenteReemplazoForm.patchValue(' ', {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: true})
    this.searchCodDocenteReemplazoForm.patchValue('', {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: true})
  }

  keypressNumber(event: any) {
    return this._utilsFn.keypressNumber(event)
  }

  displayFnCodDocentesReemplazo(docente: any): string {
    return docente?.codigo ?? ''
  }

  navToInicioReemplazoDocente(): void {
    this.router.navigate(['/reemplazo-docente-inicio'])
  }

  editarReemplazoDocente(){
    this.submitted = true
    const docenteReemplazo: any = typeof this.searchCodDocenteReemplazoForm.getRawValue() === 'object' ? this.searchCodDocenteReemplazoForm.getRawValue() : ''
    
    if ( docenteReemplazo?.funcionarioId == undefined ) this.tieneErrores["idDocenteReemplazo"] = true
    if ( this.fechaInicioDocenteReemplazo.toString() === '' ) this.tieneErrores["fechaInicioDocenteReemplazo"] = true
    if ( this.fechaFinDocenteReemplazo.toString() === '' ) this.tieneErrores["fechaFinDocenteReeemplazo"] = true
    const filtrosConErrores = Object.values(this.tieneErrores).filter(value => value === true)
    if ( filtrosConErrores.length > 0 ) {
      return
    }

    if ( this.reemplazo.idDocente === docenteReemplazo?.funcionarioId ) {
      this.tieneErrores["idDocenteReemplazo"] = true
      this.mostrarInfoModal('Aviso', 'El ID del docente reemplazante no puede ser igual al docente a reemplazar')
      return
    }

    let body = {      
      anyo: this.reemplazo.anoAcademico,
      periodoId: this.reemplazo.periodoAcademicoId,
      sedeId: this.reemplazo.idSede,
      descSede: this.reemplazo.sede,
      codigoJornada: this.reemplazo.codigoJornada,
      jornadaDesc: this.reemplazo.codigoJornada,
      idSeccion: this.reemplazo.idSeccion,
      descSeccion:this.reemplazo.seccion,
      idDocente: this.reemplazo.idDocente,
      nombreDocente: this.reemplazo.nombreDocente,
      idDocenteReemplazo: docenteReemplazo.funcionarioId,
      nombreDocenteReemplazo: `${docenteReemplazo.primerNombre} ${docenteReemplazo.apellidoPat} ${docenteReemplazo.apellidoMat}`,
      asignaturaId: this.reemplazo.asignaturaId,
      codigoAsignatura: this.reemplazo.codigoAsignatura,
      descAsignatura: this.reemplazo.descAsignatura,
      descModalidad: this.reemplazo.descMetodoFormacion,
      fechaInicio: `${this.fechaInicioDocenteReemplazo.toString().split('-')[2]}/${this.fechaInicioDocenteReemplazo.toString().split('-')[1]}/${this.fechaInicioDocenteReemplazo.toString().split('-')[0]}`,
      fechaTermino: `${this.fechaFinDocenteReemplazo.toString().split('-')[2]}/${this.fechaFinDocenteReemplazo.toString().split('-')[1]}/${this.fechaFinDocenteReemplazo.toString().split('-')[0]}`,
      tpoJornadaId: this.reemplazo.tpoJornadaId,
      metodoFormacionId: this.reemplazo.metodoFormacionId
    }
    
    this._reemplazoDocente.putEditarReemplazoDocente(body,this.reemplazo.idReemplazo).subscribe(
      (res: IResCrearReemplazoDocente) => {
        if ( res.error === null ) {
          this.router.navigate(['/reemplazo-docente-inicio'], {
            state: {
              data: {
                reemplazoDocenteEditado: true,
                nombreDocente: this.reemplazo.nombreDocente
              }
            }
          })
        } else {
          this.mostrarInfoModal('Aviso', res.error?.mensaje ?? 'Hubo un error en los servicios')
        }
      }
    )
  }

  mostrarInfoModal(titulo: string = '', texto: string = ''): void {
    this.infoModalTitulo = titulo
    this.infoModalTexto = texto
    document.getElementById('btn-modal-info')?.click()
  }
}
